function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { isPlainObject } from "./isPlainObject.js";
/**
 * Merge the contents of two or more objects together into the first object.
 * If passing "true" for first argument, the merge becomes recursive (aka. deep copy).
 * @param  {...any} args
 * @returns {Object}
 */

export var extend = function extend() {
  var deep = false;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (typeof args[0] == "boolean") {
    deep = args.shift();
  }

  var result = args[0];

  if (!result || _typeof(result) !== "object") {
    throw new Error("extendee must be an object");
  }

  var extenders = args.slice(1);
  var len = extenders.length;

  for (var i = 0; i < len; i++) {
    var extender = extenders[i];

    for (var key in extender) {
      if (extender.hasOwnProperty(key)) {
        var value = extender[key];

        if (deep && (Array.isArray(value) || isPlainObject(value))) {
          var base = Array.isArray(value) ? [] : {};
          result[key] = extend(true, result.hasOwnProperty(key) ? result[key] : base, value);
        } else {
          result[key] = value;
        }
      }
    }
  }

  return result;
};